//export const apiURL = "http://localhost:8080/api" // dev
export const apiURL = "https://func.net.ua/api" // prod